export default {
  els: document.querySelectorAll('.js-swiper'),
  init(Swiper, Navigation, Pagination) {
    this.els.forEach((el) => {
      let options = {};

      if (el.dataset.options) {
        options = JSON.parse(el.dataset.options.replace(/'/g, '"'));
      }

      const navigation =
        el.querySelector('.swiper-button-next') &&
        el.querySelector('.swiper-button-prev')
          ? {
              nextEl: el.querySelector('.swiper-button-next'),
              prevEl: el.querySelector('.swiper-button-prev'),
            }
          : {};

      const pagination = el.querySelector('.swiper-pagination')
        ? {
            el: el.querySelector('.swiper-pagination'),
            clickable: true,
          }
        : {};

      options.modules = [Navigation, Pagination];
      options.navigation = navigation;
      options.pagination = pagination;

      const swiper = new Swiper(el, options);
    });
  },
};
